module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contract-detail"
  }, [_vm._m(0), (!_vm.$media.isMobile) ? _c('contract-stage-bar', {
    attrs: {
      "contract": _vm.contract
    }
  }) : _vm._e(), _c('auto-table', {
    attrs: {
      "defines": _vm.$defines.contract,
      "unstackable": "unstackable",
      "data": _vm.contracts,
      "detail-view": true,
      "row-classes": function (record) { return record._id === _vm.contract._id ? "actived" : "inactive"; }
    }
  }), _c('router-view'), (!this.$route.meta.action) ? [(!_vm.$media.isMobile) ? [_c('h2', [_vm._v("操作")]), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui statistics buttonlike"
  }, [(_vm.$config.logic.manual_meter && _vm.$permission.has("basic.create.charges")) ? [_c('div', {
    staticClass: "statistic buttonlike",
    on: {
      "click": function($event) {
        _vm.goto_room_action("utilities")
      }
    }
  }, [_vm._m(1), _c('div', {
    staticClass: "label"
  }, [_vm._v("水电抄表")])]), _c('div', {
    staticClass: "statistic buttonlike",
    on: {
      "click": function($event) {
        _vm.goto_action("utilities_settle")
      }
    }
  }, [_vm._m(2), _c('div', {
    staticClass: "label"
  }, [_vm._v("结算水电")])])] : _vm._e(), (_vm.$permission.has("basic.create.charges")) ? _c('div', {
    staticClass: "statistic buttonlike",
    on: {
      "click": function($event) {
        _vm.goto_action("charge")
      }
    }
  }, [_vm._m(3), _c('div', {
    staticClass: "label"
  }, [_vm._v("水电费充值")])]) : _vm._e(), (_vm.contract.state === "active") ? [(_vm.contract.date_expire < _vm.contract.date_end) ? [(_vm.$permission.has("basic.create.rents")) ? _c('div', {
    staticClass: "statistic buttonlike",
    on: {
      "click": function($event) {
        _vm.goto_action("rent")
      }
    }
  }, [_vm._m(4), _c('div', {
    staticClass: "label"
  }, [_vm._v("续交租金")])]) : _vm._e()] : [_vm._m(5), (!_vm.contract.rent_by_day) ? [(_vm.$permission.has("basic.create.contracts")) ? _c('div', {
    staticClass: "statistic buttonlike",
    on: {
      "click": _vm.goto_renew
    }
  }, [_vm._m(6), _c('div', {
    staticClass: "label"
  }, [_vm._v("续签合同")])]) : _vm._e()] : _vm._e()], (_vm.$permission.has("basic.create.rents")) ? _c('div', {
    staticClass: "statistic buttonlike",
    on: {
      "click": function($event) {
        _vm.goto_action("rent_by_day")
      }
    }
  }, [_vm._m(7), _c('div', {
    staticClass: "label"
  }, [_vm._v("按日交租")])]) : _vm._e(), _c('div', {
    staticClass: "statistic buttonlike",
    class: {
      disabled: !_vm.$permission.has("basic.modify.contracts.preorderable")
    },
    on: {
      "click": function($event) {
        _vm.preorderable()
      }
    }
  }, [_c('div', {
    staticClass: "value"
  }, [_c('i', {
    staticClass: "mi"
  }, [_vm._v(_vm._s(['help_outline', 'room', 'check'][_vm.contract.preorderable || 0]))])]), _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(['预定情况未知', '可预订', '确认续租'][_vm.contract.preorderable || 0]))])]), (_vm.days_to_expired > 0 && _vm.$permission.has("basic.create.transfer_delegations")) ? _c('div', {
    staticClass: "statistic buttonlike",
    on: {
      "click": function($event) {
        _vm.goto_action("transfer_delegation")
      }
    }
  }, [_vm._m(8), _c('div', {
    staticClass: "label"
  }, [_vm._v("签署转让委托")])]) : _vm._e(), (_vm.$permission.has("basic.modify.contracts.checkout")) ? _c('div', {
    staticClass: "statistic buttonlike",
    on: {
      "click": _vm.contract_checkout
    }
  }, [_vm._m(9), _c('div', {
    staticClass: "label"
  }, [_vm._v("退房")])]) : _vm._e()] : (_vm.delegated) ? [(_vm.$permission.has("basic.modify.contracts.checkout")) ? _c('div', {
    staticClass: "statistic buttonlike",
    on: {
      "click": _vm.contract_checkout
    }
  }, [_vm._m(10), _c('div', {
    staticClass: "label"
  }, [_vm._v("退房")])]) : _vm._e()] : [_vm._m(11)]], 2), (_vm.$permission.has("basic.recall.contracts")) ? _c('div', {
    staticClass: "ui basic button grey labeled icon hide-in-mobile",
    on: {
      "click": _vm.contract_recall
    }
  }, [_c('i', {
    staticClass: "icon warning"
  }), _vm._v("撤销合同")]) : _vm._e(), (_vm.$permission.has("basic.modify.contracts.repair")) ? _c('div', {
    staticClass: "ui basic button grey labeled icon hide-in-mobile",
    on: {
      "click": _vm.contract_repair
    }
  }, [_c('i', {
    staticClass: "icon warning"
  }), _vm._v("修復合同")]) : _vm._e(), (_vm.delegated && _vm.$permission.has("basic.create.transfer_delegations")) ? _c('div', {
    staticClass: "ui basic button grey labeled icon hide-in-mobile",
    on: {
      "click": function($event) {
        _vm.cancel_transfer_delegation()
      }
    }
  }, [_c('i', {
    staticClass: "icon warning"
  }), _vm._v("取消转让委托")]) : _vm._e()])] : _vm._e(), (_vm.customers.length && _vm.$permission.has("basic.view.customers")) ? [_c('h3'), _c('form-room-customers', {
    attrs: {
      "no": _vm.no,
      "contract": _vm.contract,
      "customers": _vm.customers
    }
  })] : _vm._e(), (_vm.rents && _vm.$permission.has("basic.view.rents")) ? [_c('h2', [_vm._v("租金记录")]), _c('auto-table', {
    attrs: {
      "defines": _vm.$defines.rent,
      "unstackable": "unstackable",
      "data": _vm.rents,
      "detail-view": true
    }
  })] : _vm._e(), (_vm.charges && _vm.$permission.has("basic.view.charges")) ? [_c('h2', [_vm._v("水电充值记录")]), _c('auto-table', {
    attrs: {
      "defines": _vm.$defines.charge,
      "unstackable": "unstackable",
      "data": _vm.charges,
      "detail-view": true,
      "layout": "in_room"
    }
  })] : _vm._e()] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('span', [_vm._v("合同概况")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "value"
  }, [_c('i', {
    staticClass: "mi"
  }, [_vm._v("opacity")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "value"
  }, [_c('i', {
    staticClass: "mi"
  }, [_vm._v("invert_colors")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "value"
  }, [_c('i', {
    staticClass: "mi"
  }, [_vm._v("opacity")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "value"
  }, [_c('i', {
    staticClass: "mi"
  }, [_vm._v("event_note")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "statistic buttonlike disabled"
  }, [_c('div', {
    staticClass: "value"
  }, [_c('i', {
    staticClass: "mi"
  }, [_vm._v("event_available")])]), _c('div', {
    staticClass: "label"
  }, [_vm._v("租金已付清")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "value"
  }, [_c('i', {
    staticClass: "mi"
  }, [_vm._v("add_box")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "value"
  }, [_c('i', {
    staticClass: "mi"
  }, [_vm._v("event")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "value"
  }, [_c('i', {
    staticClass: "mi"
  }, [_vm._v("transform")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "value"
  }, [_c('i', {
    staticClass: "mi"
  }, [_vm._v("exit_to_app")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "value"
  }, [_c('i', {
    staticClass: "mi"
  }, [_vm._v("exit_to_app")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "statistic buttonlike disabled"
  }, [_c('div', {
    staticClass: "value"
  }, [_c('i', {
    staticClass: "mi"
  }, [_vm._v("exit_to_app")])]), _c('div', {
    staticClass: "label"
  }, [_vm._v("已退房")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81469890","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/mixed/ContractDetail.vue
// module id = 444
// module chunks = 0